export default {
    dependencies: ['$element', 'favoritesservice'],
    callable($element, favoritesService) {
        const shareButton = $element.querySelector(
            '[data-share-favorites-btn]'
        );
        const shareUrlField = $element.querySelector(
            '[data-share-favorites-url]'
        );
        const sharedFavoritesCopyButton = $element.querySelector(
            '[data-shared-favorites-copy-btn]'
        );
        const sharedFavoritesComposite = $element.querySelector(
            '[data-share-favorites-composite]'
        );

        if (shareButton) {
            shareButton.addEventListener('click', onShareBtnClicked);
        }
        if (shareUrlField) {
            shareUrlField.addEventListener('click', selectShareUrlFieldText);
        }
        if (sharedFavoritesCopyButton) {
            sharedFavoritesCopyButton.addEventListener(
                'click',
                onSharedCopyBtnClicked
            );
        }

        function onShareBtnClicked() {
            favoritesService.shareList().then(replaceBtnWithShareComposite);
        }

        function selectShareUrlFieldText() {
            shareUrlField.select();
        }

        function onSharedCopyBtnClicked() {
            shareUrlField.select();
            document.execCommand('copy');
        }

        function replaceBtnWithShareComposite(share) {
            shareUrlField.value = share.shareUrl;
            shareButton.classList.add('hidden');
            shareButton.setAttribute('aria-hidden', 'true');
            sharedFavoritesComposite.classList.remove('hidden');
            sharedFavoritesComposite.setAttribute('aria-hidden', 'false');
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/favoriteShareList.js